<template>
  <v-dialog v-model="show" width="29rem" light content-class="custom-dialog">
    <div class="d-flex flex-column ai-center">
      <div class="content d-flex jc-center w-100 py-10">
        {{ content }}
      </div>
      <div class="d-flex">
        <v-btn
          v-if="cancelBtn"
          @click="cancel"
          class="btn-rounded"
          :class="{ 'mr-8': confirmBtn }"
          color="blue"
          min-width="8rem"
          outlined
          x-large
          depressed
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          v-if="confirmBtn"
          @click="confirm"
          class="btn-rounded"
          color="blue"
          min-width="8rem"
          outlined
          x-large
          depressed
        >
          {{ confirmText }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
//import { createNamespacedHelpers } from "vuex";
//import { mapState, mapActions, mapMutations } from "vuex";
//const { mapState, mapActions } = createNamespacedHelpers("confirmDialog");
export default {
  data() {
    return {
      visible: false,
      resolve: null,
      reject: null,
      content: "",
      cancelText: this.$t("confirmDialog.cancel"),
      confirmText: this.$t("confirmDialog.confirm"),
      cancelBtn: true,
      confirmBtn: true
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        this.visible = value;
        if (value === false) this.cancel();
      }
    }
  },
  methods: {
    open(options) {
      this.visible = true;
      this.content = options.content;
      this.confirmText =
        options.confirmText ?? this.$t("confirmDialog.confirm");
      this.cancelText = options.cancelText ?? this.$t("confirmDialog.cancel");
      this.confirmBtn = options.confirmBtn;
      this.cancelBtn = options.cancelBtn;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      this.resolve(true);
      this.visible = false;
    },
    cancel() {
      this.resolve(false);
      this.visible = false;
    }
  }
};
</script>

<style lang="sass" scoped>
::v-deep .custom-dialog
  font-size: 0.85rem !important
  border-radius: 0.3rem
  padding: 1rem
  background: white
  .content
    color: #2b2b2b
    font-size: 1.25rem
  .btn-rounded
    border-radius: 0.5rem
</style>
